import WingHero from "../components/WingHero";
import WingPrograms from "../components/WingPrograms";
import WingPathwayNav from "../components/WingPathwayNav";
import { ScrollReveal } from "@/components/base/ScrollAnimations";
import { wingDetails } from "@/mocks/programsData";

const wingData = wingDetails.find((w) => w.wing === "Research Wing")!;

export default function ResearchWingPage() {
  return (
    <main className="min-h-screen">
      <WingHero
        badge="Research Wing"
        title="Research Wing"
        subtitle={wingData.tagline}
        description={wingData.description}
        icon={wingData.icon}
        iconBg={wingData.iconBg}
      />

      {/* What Is Section */}
      <section className="bg-tie-grey-light py-16 md:py-24">
        <div className="w-full px-4 md:px-8 lg:px-12">
          <div className="max-w-4xl mx-auto">
            <ScrollReveal>
              <div className="text-center mb-8 md:mb-10">
                <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-md bg-tie-navy/10 mb-4 md:mb-6">
                  <span className="text-xs font-semibold text-tie-navy uppercase tracking-wider">
                    / What This Wing Does
                  </span>
                </div>
                <h2 className="font-serif text-2xl md:text-3xl lg:text-4xl font-bold text-tie-text-primary leading-tight">
                  Evidence That Drives Sector Decisions
                </h2>
              </div>
            </ScrollReveal>

            <ScrollReveal delay={150}>
              <div className="space-y-4 md:space-y-5">
                <p className="text-base md:text-lg text-tie-text-secondary leading-relaxed">
                  The Research Wing produces peer-reviewed, factory-validated research that guides policy,
                  investment, and operational priorities across Bangladesh's textile ecosystem. Every research
                  output is grounded in real factory conditions — not laboratory theory.
                </p>
                <p className="text-base md:text-lg text-tie-text-secondary leading-relaxed">
                  Through PIARC's applied research circles, IJTAI's bi-annual journal, and AIRCon's annual
                  conference, this wing creates a continuous knowledge pipeline. Factory engineers, academics,
                  and industry practitioners collaborate to solve live production problems and publish findings
                  that the entire sector can act upon.
                </p>
              </div>
            </ScrollReveal>

            <ScrollReveal delay={300}>
              <div className="mt-8 md:mt-10 grid grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
                {[
                  { label: "Research Circles", value: "12+" },
                  { label: "Publications", value: "IJTAI" },
                  { label: "Annual Conference", value: "AIRCon" },
                  { label: "Factory Partners", value: "30+" },
                ].map((stat) => (
                  <div key={stat.label} className="text-center p-4 md:p-5 rounded-xl bg-white border border-tie-grey-dark">
                    <p className="font-serif text-2xl md:text-3xl font-bold text-tie-navy mb-1">{stat.value}</p>
                    <p className="text-xs md:text-sm text-tie-text-muted">{stat.label}</p>
                  </div>
                ))}
              </div>
            </ScrollReveal>
          </div>
        </div>
      </section>

      <WingPrograms
        title="Programmes in the Research Wing"
        programs={wingData.items}
        icon={wingData.icon}
        iconBg={wingData.iconBg}
      />

      <WingPathwayNav />
    </main>
  );
}